import React, { useEffect } from "react";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { UPDATE_SITE_SETUP } from "../apiEndpoints";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import UpdateSiteForm from "../forms/updateSite/UpdateSiteForm";

const UpdateSitePage = () => {
  const { data, isLoaded, error, getData } = useGetData();

  useEffect(() => {
    getData(UPDATE_SITE_SETUP);
  }, []);

  return (
    <MainPageLayout headerConfig={{ title: "Update Site" }}>
      {isLoaded && !error ? (
        <UpdateSiteForm siteSetup={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default UpdateSitePage;
